import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../service/api/actionCreator';
import * as MessageActions from '../../messageBox/actions/actions';
import {buildErrorMessage} from '../../util/errorUtils';

export const updateMenuNavigation = (value) => ({
  'type': ActionTypes.UPDATE_MENU_NAVIGATION,
  'payload': value,
});

export const showSecondaryMenu = (value) => ({
  'type': ActionTypes.SHOW_SECONDARY_MENU,
  'payload': value,
});

export const toggleMenuWidth = () => ({
  'type': ActionTypes.TOGGLE_MENU_WIDTH,
});

export const addItemsToMenu = (availableOptions) => ({
  'type': ActionTypes.ADD_ITEMS_TO_MENU,
  'payload': availableOptions,
});

export const getFavoriteOptions = () => apiActionCreator({
  'endpoint': '/users/favoriteOptions',
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_FAVORITE_OPTIONS,
    ActionTypes.GOTTEN_FAVORITE_OPTIONS,
    [
      ActionTypes.GOTTEN_FAVORITE_OPTIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addFavoriteOption = (option) => apiActionCreator({
  'endpoint': '/users/favoriteOptions',
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_FAVORITE_OPTION,
    [
      {
        'type': ActionTypes.ADDED_FAVORITE_OPTION,
        'payload': option,
      },
      MessageActions.addMessageBoxInfo('Opción agregada a favoritos.'),
    ],
    [
      ActionTypes.ADDED_FAVORITE_OPTION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': {option},
});

export const removeFavoriteOption = (option) => apiActionCreator({
  'endpoint': '/users/favoriteOptions',
  'authenticated': true,
  'types': [
    ActionTypes.REMOVING_FAVORITE_OPTION,
    [
      {
        'type': ActionTypes.REMOVED_FAVORITE_OPTION,
        'payload': option,
      },
      MessageActions.addMessageBoxInfo('Opción retirada de favoritos'),
    ],
    [
      ActionTypes.REMOVED_FAVORITE_OPTION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': {option},
});

export const processOptionPopularity = (option) => apiActionCreator({
  'endpoint': '/users/popularOptions',
  'authenticated': true,
  'types': [
    ActionTypes.PROCESSING_OPTION_POPULARITY,
    ActionTypes.PROCESSED_OPTION_POPULARITY,
    ActionTypes.PROCESSED_OPTION_POPULARITY_FAILED,
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': {option},
});

export const getUserOptions = () => apiActionCreator({
  'endpoint': '/users/options',
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_USER_OPTIONS,
    ActionTypes.GOTTEN_USER_OPTIONS,
    ActionTypes.GOTTEN_USER_OPTIONS_FAILED,
  ],
  'microservice': 'part',
  'method': 'GET',
});
